"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildDefaultAriaLabelForProgress = void 0;

// TODO - localise output
var buildDefaultAriaLabelForProgress = function buildDefaultAriaLabelForProgress(progress) {
  return "".concat((progress * 100).toFixed(0), "%");
};

exports.buildDefaultAriaLabelForProgress = buildDefaultAriaLabelForProgress;